import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    const collapsed = localStorage.getItem("admin.sidebar.collapsed") === "1"
    this.element.classList.toggle("sidebar-collapsed", collapsed)
  }

  toggle() {
    const next = !this.element.classList.contains("sidebar-collapsed")
    this.element.classList.toggle("sidebar-collapsed", next)
    localStorage.setItem("admin.sidebar.collapsed", next ? "1" : "0")
  }
}
